// frontend/src/components/Registro/VerificarCuenta.js

import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import './Registro.css';

const VerificarCuenta = () => {
  const { token } = useParams();
  const [estado, setEstado] = useState('cargando'); // cargando | exito | error | expirado
  const [mensaje, setMensaje] = useState('');
  const [email, setEmail] = useState('');
  const [reenviando, setReenviando] = useState(false);
  const [reenviado, setReenviado] = useState(false);

  useEffect(() => {
    let activo = true;
    fetch(`/api/registro/verificar/${token}`)
      .then(async (res) => {
        const data = await res.json();
        if (!activo) return;
        if (res.ok) {
          setEstado('exito');
          setMensaje(data.message);
        } else {
          setEstado(data.expirado ? 'expirado' : 'error');
          setMensaje(data.error || 'No se pudo verificar tu cuenta.');
        }
      })
      .catch(() => {
        if (activo) {
          setEstado('error');
          setMensaje('Error de conexión con el servidor.');
        }
      });
    return () => { activo = false; };
  }, [token]);

  const handleReenviar = async (e) => {
    e.preventDefault();
    setReenviando(true);
    try {
      await fetch('/api/registro/reenviar-verificacion', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      setReenviado(true);
    } catch (err) {
      // El endpoint siempre responde genérico; un error de red no debe
      // dejar al usuario sin feedback.
      setReenviado(true);
    } finally {
      setReenviando(false);
    }
  };

  return (
    <div className="registro-container">
      <div className="registro-card registro-card-exito">
        <img src="/isotipotransparente.png" alt="" className="registro-icono-exito" />

        {estado === 'cargando' && <h1>Verificando tu cuenta...</h1>}

        {estado === 'exito' && (
          <>
            <h1>¡Cuenta verificada!</h1>
            <p>{mensaje}</p>
            <Link to="/login" className="btn-registro-primary">Ir a iniciar sesión</Link>
          </>
        )}

        {(estado === 'error' || estado === 'expirado') && (
          <>
            <h1>{estado === 'expirado' ? 'El enlace expiró' : 'No pudimos verificar tu cuenta'}</h1>
            <p>{mensaje}</p>

            {!reenviado ? (
              <form onSubmit={handleReenviar} className="registro-form registro-form-inline">
                <div className="registro-field">
                  <label>Tu correo</label>
                  <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                </div>
                <button type="submit" className="btn-registro-primary" disabled={reenviando}>
                  {reenviando ? 'Enviando...' : 'Reenviar enlace de verificación'}
                </button>
              </form>
            ) : (
              <p className="registro-hint">Si el correo existe y está pendiente de verificar, te enviamos un nuevo enlace. Revisa tu bandeja de entrada.</p>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default VerificarCuenta;
